import { render, staticRenderFns } from "./EditOrderAddressDialog.vue?vue&type=template&id=3c206b2f&scoped=true"
import script from "./EditOrderAddressDialog.vue?vue&type=script&lang=js"
export * from "./EditOrderAddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c206b2f",
  null
  
)

export default component.exports